export const PopupType = {
    DocumentUpload: 'DocumentUpload',
    ClientAgreement: 'ClientAgreement',
    };